export enum EOrderStatus {
  BUILDING = 'building',
  IN_CHECKOUT = 'in-checkout',
  SPLITTING_CHECK = 'splitting-check',
  GROUP_PAYING = 'group-paying',
  COMPLETED = 'completed',
  PENDING = 'pending',
}
